export default async function init() {
  const reactApp = document.querySelector("[data-react-app]");

  if (reactApp) {
    const React = await import(/* webpackChunkName: "react" */ "react");
    const ReactDOM = await import(
      /* webpackChunkName: "react_dom" */ "react-dom/client"
    );
    const { default: App } = await import(
      /* webpackChunkName: "react_app" */ "../Containers/App"
    );
    const app = document.createElement("div");
    app.id = "root";
    document.body.appendChild(app);
    const root = ReactDOM.createRoot(app);
    root.render(<App />);
    const event = new Event("react:app:init");
    window.dispatchEvent(event);
  }
}
